import { RTU } from '../types/RTU';
import { RTUData } from '../types/RtuData';
import { resolveRtuSerialNo } from './rtuIdentity';

export const toRtuActionTarget = (rtu: RTUData): RTU => ({
  address: rtu.ipAddress || rtu.rtuHeader?.publicIp || '',
  id: rtu.id,
  serialNo: resolveRtuSerialNo(rtu),
  name: rtu.rtuStaticData?.name || `RTU ${rtu.id}`,
  client: rtu.rtuStaticData?.client || '',
  location: rtu.rtuStaticData?.location || '',
  latitude: Number(rtu.rtuStaticData?.latitude || 0),
  longitude: Number(rtu.rtuStaticData?.longitude || 0),
  status:
    rtu.onlineStatus === true
      ? 'online'
      : rtu.onlineStatus === false
        ? 'offline'
        : 'unknown',
  configVersion: rtu.rtuStaticData?.cfgVersion || '',
  deploymentVersion: rtu.rtuStaticData?.dpyVersion || '',
  diskUsage: 0,
  cpuUsage: 0,
  lastData: rtu.timestamp || '',
  installDate: rtu.rtuStaticData?.installationDate || '',
  publicIPAddress: rtu.rtuHeader?.publicIp || rtu.ipAddress || '',
  localIPAddress: rtu.rtuHeader?.ethernetIP || '',
  reportingToServer: null,
  lastConfigUpdate: null,
  groupId: 0,
  systemRestart: false,
  provider: '',
  modemIP: rtu.rtuHeader?.modemIP || '',
  ethernetIP: rtu.rtuHeader?.ethernetIP || '',
  field: rtu.rtuStaticData?.wellID || '',
});
